import Service from "../../AuthService";

const RRPayoff = {
    getRRPayoff(page=1){
        return Service.get("/rr_payoff?page="+page);
    },
    createRRPayoff(data) {
        return Service.post("/rr_payoff", data)
    },
    getRRPayoffById(id){
        return Service.get("/rr_payoff/"+id)
    },
    updateRRPayoff(id, data) {
        return Service.put("/rr_payoff/" + id, data)
    },
    deleteRRPayoff(id) {
        return Service.delete("/rr_payoff/" + id)
    },
    getVendorPayoff(){
        return Service.get("/vendor_payoff");
    },
    getRRFromVendor(data){
        return Service.post("/rr_payoff_vendor",data)
    },
    searchRRPayoff(page,data){
        return Service.post("/rr_payoff_payment_search?page="+page,data)
    },
    getRRPayoffIdfAll(){
        return Service.get("/select_rr_payoff_all");
    },
    getProjectByVendor(vendor_id){
        return Service.get("/project_by_vendor?vendor_id="+vendor_id);
    },
    generateCS(date){
        return Service.get('/generate_cs_number?date='+date);
    },
    createTax(id){
        return Service.get('/generate_cs_tax?id='+id);
    },

    //get vendor po for payoff
    getVendorByfPo(){
        return Service.get("/vendor_form_po");
    },
    getPOByVendor(vendor_id){
        return Service.get("/purchase_by_vendor_payoff?vendor_id="+vendor_id);
    },

    //get cheque pay
    getChequeRRPayoff(page){
        return Service.get("/cheque-list-pay?page="+page);
    },
    updateChequeRRPayoff(id,data){
        return Service.put("/cheque-list-pay/"+id,data);
    },
    showChequeRRPayoff(id){
        return Service.get("/cheque-list-pay/"+id);
    },
    deleteChequeRRPayoff(id){
        return Service.delete("/cheque-list-pay/"+id);
    },

    searchChequeRRPayoff(data){
        return Service.get("/search_cheque_list_pay?page="+data.page+"&amount="+data.amount
            +"&cheque_bank_id="+data.cheque_bank_id+"&end_date="+data.end_date+"&ref_no="+data.ref_no
            +"&start_date="+data.start_date+"&status="+data.status+"&vendor="+data.vendor)
    },
    updateCsNo(data){
        return Service.post('/update_cs_number',data)
    }
};

export default RRPayoff
